import React from "react";
import {
  ActiveLine,
  CompletedLine,
  Container,
  InactiveLine,
  Row,
} from "components/designV2/progressIndicator/progressIndicator.styles";

interface ProgressIndicatorProps {
  currentStep: number;
  steps: number;
}

export const ProgressIndicator = (
  props: ProgressIndicatorProps,
): React.ReactElement => (
  <Row>
    {Array.from({ length: props.steps }).map((_, index) => (
      <Container key={`progress-step-${index}`}>
        {props.currentStep === index + 1 ? (
          <ActiveLine />
        ) : props.currentStep > index + 1 ? (
          <CompletedLine />
        ) : (
          <InactiveLine />
        )}
      </Container>
    ))}
  </Row>
);
